export const c_expandable_section_m_truncate__content_LineClamp = {
  "name": "--pf-v6-c-expandable-section--m-truncate__content--LineClamp",
  "value": "3",
  "var": "var(--pf-v6-c-expandable-section--m-truncate__content--LineClamp)"
};
export default c_expandable_section_m_truncate__content_LineClamp;